import * as THREE from 'three';

export const cssToThreeColor = (css: string | number): THREE.Color => {
  return new THREE.Color(css);
};

export const cssToHexColor = (css: string): number => {
  return new THREE.Color(css).getHex();
};

// Apply ratio to 'Luminosity' part of color in HSL space
export function multiplyThreeColor(
  color: THREE.Color,
  mul: number,
): THREE.Color {
  const hsl: THREE.HSL = {h: 0, s: 0, l: 0};
  color.getHSL(hsl);
  const newColor = new THREE.Color();
  hsl.l *= mul;
  newColor.setHSL(hsl.h, hsl.s, hsl.l);
  return newColor;
}

export function multiplyHexColor(color: number, mul: number): number {
  return multiplyThreeColor(new THREE.Color(color), mul).getHex();
}
